export { default } from './CardThumbnail';
